import "../../../../stylesheets/campaign";
import "../../../../stylesheets/causes";
import "../../../../stylesheets/templates/causes/template-1";
import "../../../../stylesheets/templates/causes/template-2";
import "./index";
import "./greeting_cards";
import "select2";
import "select2/dist/css/select2.css";

$(".standard-select")
  .select2({
    placeholder: "",
    allowClear: true,
  })
  .next(".select2-container")
  .find("span.select2-selection--single")
  .css("border-radius", "57px");

$("#recruiter_form_card .selection").on("click", function () {
  if ($(".select2-results")) {
    $(".select2-results").hide();
    window.scroll(0, $(window).scrollTop() + 1);
  }

  $(".select2-search__field").on("input", function () {
    if (this.value) {
      $(".select2-results").show();
    } else {
      $(".select2-results").hide();
      window.scroll(0, $(window).scrollTop() - 1);
    }
  });
});
